import {
	Component,
	Input,
	Output,
	EventEmitter,
	OnInit,
	OnDestroy
} from '@angular/core';
import { BUTTON_TYPES } from '@edassist-ui/button';
import {
	DROPDOWN_ORIENTATION,
	DROPDOWN_TYPES,
	DropdownService
} from '@edassist-ui/dropdown';
import { constants, NotificationFilterTypes } from '@edassist/common';
import { InputDropdownOption } from '@edassist-ui/input-dropdown';
import { Subscription } from 'rxjs';
@Component({
	selector: 'ea-dropdown-icon-item',
	templateUrl: './dropdown-icon-item.component.html',
	styleUrls: ['./dropdown-icon-item.component.scss']
})
export class DropdownIconItemComponent implements OnInit, OnDestroy {
	@Input() notificationTypeOptions: Array<InputDropdownOption>;
	@Input() selectedTypeValue: NotificationFilterTypes;
	@Input() hasSelectedTypeValue = true;
	@Input() selectedNotificationFilterIcon: string;
	@Input() dropdownId: string;
	@Input() isActive = false;

	// eslint-disable-next-line @angular-eslint/no-output-on-prefix
	@Output() readonly onChange: EventEmitter<NotificationFilterTypes> =
		new EventEmitter<NotificationFilterTypes>();

	BUTTON_TYPES = BUTTON_TYPES;
	DROPDOWN_TYPES = DROPDOWN_TYPES;
	DROPDOWN_ORIENTATION = DROPDOWN_ORIENTATION;
	constants = constants;
	selectedOption: NotificationFilterTypes;

	private readonly subscriptions = new Subscription();
	constructor(private readonly dropdownService: DropdownService) {}

	ngOnInit(): void {
		this.subscriptions.add(
			this.dropdownService.closeDropDownEvent.subscribe((dropDownId) => {
				if (dropDownId === constants.dropdownIds.notificationTypesList) {
					this.dropdownService.open(
						constants.dropdownIds.notificationTypesList
					);
				}
			})
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}

	dropdownValueChange(value: NotificationFilterTypes, index: number): void {
		this.selectedOption = value;
		this.onChange.emit(this.selectedOption);
		this.dropdownService.close(constants.dropdownIds.notificationTypesList);
	}

	closeDropdown(event: FocusEvent) {
		const dropdownMenu = Array.from(document.getElementsByClassName('dropdown-icon-option'));
		if (dropdownMenu && !dropdownMenu.some(element => element.contains(event.relatedTarget as Node))) {
			this.dropdownService.close(this.dropdownId);
		}
	}

	handleKeydown(event: KeyboardEvent, value: NotificationFilterTypes, index: number): void {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			this.dropdownValueChange(value, index);
		}
	}
}
